/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, useMediaQuery } from "@mui/material";
import { getLatLng } from 'react-places-autocomplete'
import { Location } from 'history'
import { FC, useCallback, useEffect, useMemo, useState } from "react"
import { useHistory, Prompt } from "react-router-dom";
import { NOME_CLIENTE_MAX_LENGTH, POTENCIA_MINIMA_ENGENHARIA } from "src/components/projetos/constants";
import { FormDados } from "./FormDados";
import { VerticaisManager, paths } from "src/components/vendas/VerticaisManager";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import { EquipeType } from "src/providers/cadastros/ContaProvider/types";
import { getCidades, getGruposEstrutura, getEstados, getLimitacoesProjetos, getDistribuidoresPorTipoDeConta, getRevendas, distribuidoresPorTipoDeConta$, revendas$, getEstadosServico, getRegioes, regioes$, estadosServico$, getDistribuidores, contaUsuario$, CacheType, verificarSegmentoConta } from "src/store/global.store";
import { formState$ } from "src/store/vendas/projetos/store";
import { debounce } from "lodash";
import { Map } from "src/components/projetos/Map";
import { Regiao } from "src/types";
import { projetoSalvoComSucessoDialog } from "src/components/projetos/utils/projetoSalvoComSucessoDialog";
import { ListUtil } from "src/framework/commons/ListUtil";
import { Projeto, ProjetoTipoType, SegmentoType } from "src/components/projetos/types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { ContaUsuario } from "src/store/global.store.types";
import theme from "src/theme/light";
import { notifierStore } from "src/framework/store/NotifierStore";
import { safeGeocodeByAddress } from "src/framework/commons/MapsUtil";
import * as Sentry from "@sentry/react";
import { DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.constants";
import { useProjetoPersonalizadoHibridoStore } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.store";

interface GetLatLngFromAddressType {
  cep: string;
  enderecoProposta: string;
  cidadeNome: string;
  estadoId: string;
  numero?: string;
  bairro?: string;
}

interface FormInicialProperties {
  segmento?: SegmentoType;
}

const TITULO_MAX_LENGTH = 100

const manager: VerticaisManager = new VerticaisManager(paths, api, apiNoLoading);
const contasProvider = new ContaProvider();

const initLoad = async () => {
  await Promise.all([
    getEstados(),
    getRegioes(),
    getCidades(),
    getGruposEstrutura(),
    getLimitacoesProjetos(),
    getDistribuidores(),
    getDistribuidoresPorTipoDeConta(),
    getRevendas(),
    getEstadosServico({ force: true })
  ])
}

const ProjetosFormInicialPersonalizadoHibrido: FC<FormInicialProperties> = ({ segmento }) => {
  const history = useHistory<{ allowAccess?: boolean; noReset?: boolean; done?: boolean; tipo?: ProjetoTipoType }>();
  const projetoState = useProjetoPersonalizadoHibridoStore(state => state.state.data)
  const { changeValue, reset } = useProjetoPersonalizadoHibridoStore(state => state.actions)
  
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$);
  const distribuidorsState = useObservable(distribuidoresPorTipoDeConta$);
  const regioes = useObservable(regioes$)
  const revendasState = useObservable(revendas$);
  const estadosServico = useObservable(estadosServico$);

  const [checkSegmentoConta, setCheckSegmentoConto] = useState<boolean>(false);
  const [errorState, setErrorState] = useState<string[]>([]);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null);
  const [oldFormState] = useState(DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO)

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const resetState = useCallback(()=> {
    reset();
    formState$.next(DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO);
  },[reset, projetoState.isEdit])

  useEffect(()=>{
    if (projetoState?.tipo !== "personalizado") {
      changeValue({ tipo:  "personalizado" })
    }
  },[history.location.search, projetoState?.tipo])

  const canNavigate = useCallback((location: Location | null = null)=>{
    const allowedLocations = ['/projetos/.*/novo', 'edicao$', 'clonar$']
    const localLocation = location || history.location

    const loc = localLocation as Location<{ done: boolean }>

    return loc.state?.done || allowedLocations.some(item => {
      return loc?.pathname.match(new RegExp(item))
    })
  },[history.location])

  useEffect(() => {
    return () => {
      if (!canNavigate()) {
        resetState();
      }
    }
  },[canNavigate, resetState, history])

  useEffect(()=>{
    if (projetoState?.isEdit) {
      if (history.location.search && history.location.search.includes('reativar')) {
        changeValue({
          reativar: true,
          recalcular: true,
        });
      }
      return;
    }
    if (!history.location.state?.noReset) {
      resetState();
    }
  }, [projetoState?.isEdit, history, resetState])

  const init = useCallback(()=>{
    const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
    setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)
  },[])

  useEffect(() => {
    initLoad().then(() => {
      init()
    })
  }, [init]);  
  
  useEffect(()=>{
    if (!checkSegmentoConta && projetoState?.segmento) {
      verificarSegmentoConta({ 
        goBack: true,
        segmento: projetoState?.segmento ||'on', 
        revendaId: projetoState?.revenda_id || projetoState?.revenda?.id || undefined, 
        distribuidorId: projetoState?.distribuidor_id || projetoState?.distribuidor?.id || undefined,
      });
      setCheckSegmentoConto(true);
    }
  },[projetoState?.segmento, projetoState?.revenda_id, projetoState?.distribuidor_id, projetoState?.revenda?.id, projetoState?.distribuidor?.id, checkSegmentoConta]);

  const getLatLngFromAddress = useCallback((payload: GetLatLngFromAddressType) => {
    const { cep, cidadeNome, estadoId, numero, bairro, enderecoProposta } = payload;
    if (!estadoId || !cidadeNome) return;
    const endereco = `${enderecoProposta || ''}, ${numero || ''}, ${bairro || ''}, ${cidadeNome}, ${estadoId}, ${cep || ''}`
    safeGeocodeByAddress(endereco)
    .then(res => getLatLng(res[0])).then(({lat, lng}) => {
      changeValue({ latitude: lat, longitude: lng })
    }).catch(err => {
      changeValue({ latitude: 0, longitude: 0 })
      notifierStore.setNotifier({
          title: "Aviso",
          content: "Não foi possível obter a localização a partir do endereço fornecido.",
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true);
    })
  },[])

  const getLatLngFromAddressDebounced = useCallback(
    debounce((payload: GetLatLngFromAddressType) => {
      getLatLngFromAddress(payload)
    }, 800),
    []
  );
  
  useEffect(()=>{
    getLatLngFromAddressDebounced({
      cep: projetoState?.cep || '',
      cidadeNome: projetoState?.cidade?.nome || '',
      estadoId: projetoState?.estado?.id || '',
      numero: projetoState?.numero || '',
      enderecoProposta: projetoState?.endereco_proposta || '',
      bairro: projetoState?.bairro || '',
    })
  },[projetoState.tipo, getLatLngFromAddressDebounced, projetoState.endereco_proposta, projetoState.cep, projetoState.cidade, projetoState.estado, projetoState.numero, projetoState.bairro])

  const onClickNext = useCallback((state: any)=>{
    formState$.next({...formState$.getValue(), ...state})

    const urlsFromTipo: {[index: string]: string} = {
      personalizado: '/projetos/hibrido/personalizados/novo',
    }
    
    const urlsFromTipoEdicao: {[index: string]: string} = {
      personalizado: `/projetos/${state.id}/hibrido/personalizados/edicao`,
    }

    const urlsFromTipoClonar: {[index: string]: string} = {
      personalizado: `/projetos/${state.id}/hibrido/personalizados/clonar`,
    }

    if (urlsFromTipo[state.tipo]) {
      if (state.clonar_projeto) {
        history.push(urlsFromTipoClonar[state.tipo], { allowAccess: true })
        return
      }
      
      if (state.isEdit) {
        history.push(urlsFromTipoEdicao[state.tipo], { allowAccess: true })
        return
      }
      history.push(urlsFromTipo[state.tipo], { allowAccess: true })
    }
  },[history])

  const afterSave = useCallback((response: IDataResponse) => {
    projetoSalvoComSucessoDialog(response?.data?.[0]?.codigo_venda, history, {
      onConfirmation: () => reset(),
      tipoProjeto: 'personalizado_hibrido',
    })
  }, [history, projetoState?.tipo])

  const validate = useCallback(() => {
    const _errorState = [...errorState]
    const messages: string[] = [];

    const data: Partial<Projeto> = {...projetoState}

    if (!data?.cliente_proposta){
      messages.push("O campo nome do cliente é obrigatório");
      _errorState.push("cliente_proposta")
    }

    if (data.cliente_proposta && data.cliente_proposta.length > NOME_CLIENTE_MAX_LENGTH) {
      messages.push(`O campo nome do cliente deve ter no máximo ${NOME_CLIENTE_MAX_LENGTH} caracteres`);
      _errorState.push("cliente_proposta")
    }


    if (data?.titulo && data?.titulo?.length > TITULO_MAX_LENGTH) {
      messages.push("O campo título deve ter no máximo 100 caracteres");
      _errorState.push("titulo")
    }

    if (!data?.cidade) {
      messages.push("O campo cidade é obrigatório");
      _errorState.push("cidade_id")
    }

    if (!data?.distribuidor_id && !data?.distribuidor?.id) {
        messages.push("O campo distribuidor é obrigatório");
        _errorState.push("distribuidor_id")
    }

    if(data?.email_proposta){
      if (!ValidateUtil.isValidEmail(data?.email_proposta)) {
        messages.push("E-mail inválido");
        _errorState.push("email_proposta")
      }else{
        ListUtil.removeItem(_errorState, "email_proposta")
      }
    }else{
      ListUtil.removeItem(_errorState, "email_proposta")
    }

    if (messages.length > 0) {
      setErrorState(_errorState)
      notifierStore.setNotifier({
          title: "Aviso",
          content: messages,
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true)
    }

    return messages.length === 0;
  }, [errorState, projetoState])

  const mostrarOpcaoServico = useMemo(()=>{
    if (!projetoState?.estado?.id) return true;
    const reg = regioes?.data || []
    const estadosPermitemServico: string[] = (estadosServico?.data || []).map((item: any) => item.regiao_id)
    const currentRegioes: string[] = reg.filter((item: Regiao) => {
      if (!item.estados || item.estados.length === 0) return false;
      const ids = item.estados.map((estado: any) => estado.estado_id)
      return ids.includes(projetoState?.estado?.id)
    }).map((item: any) => item.id)
    return estadosPermitemServico.some(item => {
      if (currentRegioes.includes(item)) return true;
      return false;
    })
  },[regioes, projetoState?.estado, estadosServico])

  const showMap = useMemo(()=>{
    if (isMobile) return false;
    if (!projetoState.latitude) return false;
    if (!projetoState.longitude) return false;
    if (!projetoState.endereco_proposta) return false;
    if (!projetoState.cidade) return false;
    if (!projetoState.estado) return false;
    return true;
  },[projetoState.cidade, projetoState.endereco_proposta, projetoState.estado, projetoState.latitude, projetoState.longitude])
 
  const captureData = useCallback(async(data: any) => {
    if (!validate()) return

    const state = { ...data };

    const distribuidores = distribuidoresPorTipoDeConta$.getValue();

    if (state?.distribuidor === undefined) {
      const idxDistribuidor = distribuidores.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.distribuidor_id)
      if (idxDistribuidor > -1) {
        state.distribuidor = distribuidores.data[idxDistribuidor]
      }
    }

    if (state?.revenda === undefined) {
      const idxRevenda = revendasState?.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.revenda_id)
      
      if (idxRevenda > -1) {
        state.revenda = revendasState.data[idxRevenda]
      } else {
        if (distribuidorRevendaUsuario?.revenda_id && distribuidorRevendaUsuario?.revenda_nome && distribuidorRevendaUsuario?.revenda_cnpj_cpf) {
          state.revenda = {
            id: distribuidorRevendaUsuario.revenda_id,
            nome: distribuidorRevendaUsuario.revenda_nome,
            cnpj_cpf: distribuidorRevendaUsuario.revenda_cnpj_cpf,
          }
        }
      }
    }

    const cpfCnpjDistribuidor = state?.distribuidor?.cnpj_cpf;

    if (!state?.codigo_venda) {
      if (cpfCnpjDistribuidor === "" || cpfCnpjDistribuidor === undefined || cpfCnpjDistribuidor === null) {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: "Distribuidor não informado ou CNPJ inválido!",
            timeOut: 3000,
            onClose: () => {
                notifierStore.setOpen(false);
            }
        })
        notifierStore.setOpen(true);
        return;
      }
    }

    const hasRevenda = !!state?.revenda;

    if ((oldFormState?.distribuidor?.id !== state?.distribuidor?.id) || (oldFormState?.distribuidor?.id === state?.distribuidor?.id && hasRevenda && oldFormState?.revenda?.id !== state?.revenda?.id)) {
      let codigoDistribuidorRevenda = state?.distribuidor?.id;
      
      if (hasRevenda) {
          codigoDistribuidorRevenda = state?.revenda?.id;
      }

      const responseEquipe: EquipeType | null = await contasProvider.getEquipe(codigoDistribuidorRevenda, state.segmento);

      state.ev_id = responseEquipe?.ev_id;
      state.supervisor_id = responseEquipe?.supervisor_id;
      state.assistente_id = responseEquipe?.assistente_id;
    }
    
    state.distribuidor_id = state?.distribuidor?.id;
    state.cidade_id = state?.cidade?.id;
    state.estado_id = state?.estado?.id;
    
    return state;
  },[distribuidorRevendaUsuario, revendasState, oldFormState?.distribuidor?.id, oldFormState?.revenda?.id, validate])

  const onSave = useCallback(async(data: any, callback: any = null) => {
    const state = await captureData(data)

    if (!state) {
      Sentry.captureMessage("onSave - captureData, state vazio", {
        level: "warning",
        extra: { data, state }
      });

      notifierStore.setNotifier({
          title: "Atenção!!!",
          content: "Não foi possível salvar o projeto, verifique os campos preenchidos!",
          timeOut: 3000,
          onClose: () => {
              notifierStore.setOpen(false);
          }
      })
      notifierStore.setOpen(true);

      return;
    }
    
    if (state?.id === 0) {
      delete state.id
    }

    delete state?.limitacao_projeto;
    delete state.ev
    delete state.distribuidor
    delete state.revenda
    delete state.analista
    delete state.cidade
    delete state.revisoes

    const payload = {
      id: state?.id,
      titulo: state.titulo,
      assistente_id: state.assistente_id,
      supervisor_id: state.supervisor_id,
      auto_comissao: state.auto_comissao,
      cidade_id: state.cidade_id,
      cliente_proposta: state.cliente_proposta,
      codigo_venda: state.codigo_venda,
      cpf_cnpj_proposta: state.cpf_cnpj_proposta ? state.cpf_cnpj_proposta.replace(/[^a-zA-Z0-9]/g,'') : '',
      distribuidor_id: state.distribuidor_id,
      email_proposta: state.email_proposta,
      endereco_proposta: state.endereco_proposta,
      estado_id: state.estado_id,
      ev_id: state.ev_id,
      latitude: state.latitude,
      longitude: state.longitude,
      nota_fiscal_triangular: state.nota_fiscal_triangular,
      observacao: state.observacao,
      prioridade: state.prioridade,
      revenda_id: state.revenda_id,
      segmento: state.segmento,
      setor: state.setor,
      situacao: state.situacao,
      telefone_proposta: state.telefone_proposta,
      tipo: state.tipo,
      engenharia: (state.tipo?.includes('vertical') || Number(state?.potencia) > POTENCIA_MINIMA_ENGENHARIA),
      endereco: {
        cep: state.cep?.replace(/\D/g, ""),
        logradouro: state.endereco_proposta,
        bairro: state.bairro,
        numero: state.numero,
        cidade_id: state.cidade_id,
        estado_id: state.estado_id
      }
    }

    if (!payload.revenda_id) {
      Object.assign(payload, {
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
      })
    }

    manager.save({
      row: payload,
      primaryKey: payload?.id
    }).then((response: IDataResponse) => {
      if ([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)) {
        if (typeof callback === 'function') callback(response)
      }
    })
   }, [captureData])

  useEffect(() => {
    const permissions = PermissionUtil.getPermissions();
    if (!projetoState?.isEdit && 
      PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VISUALIZAR_FILIAIS, permissions) 
      && !PermissionUtil.isAdministrador(permissions) 
      && contaUsuario?.data?.filiais?.length 
      && contaUsuario?.data?.distribuidor?.id
    ) {
      changeValue({ distribuidor_id: contaUsuario?.data?.distribuidor?.id, distribuidor: contaUsuario?.data?.distribuidor })
    }
  },[contaUsuario?.data?.distribuidor, contaUsuario?.data?.filiais?.length, projetoState?.isEdit])

  useEffect(() => {
    if (!distribuidorRevendaUsuario || projetoState?.distribuidor?.id) {
      return;
    }

    if (distribuidorRevendaUsuario.isIntelbras) {
      return;
    }

    const distribuidorId = distribuidorRevendaUsuario?.distribuidor_id;
    const revendaId = distribuidorRevendaUsuario?.revenda_id;

    const distribuidores = distribuidorsState?.data;
    const distribuidor = distribuidores.find((d: any) => d.id === distribuidorId);

    const revendas = revendas$.getValue().data;
    const revenda = revendaId ? revendas.find(r => r.id === revendaId) : undefined;

    changeValue({
      distribuidor_id: distribuidorId,
      distribuidor: distribuidor || undefined,
      ...(revendaId
        ? {
            revenda_id: revendaId,
            revenda: revenda || undefined,
          }
        : {}),
    });

    verificarSegmentoConta({
      goBack: true,
      segmento: projetoState?.segmento || 'on',
      revendaId: revendaId || projetoState?.revenda?.id || undefined,
      distribuidorId: distribuidorId || projetoState?.distribuidor?.id || undefined,
    });
  }, [ projetoState?.distribuidor?.id, projetoState?.segmento, projetoState?.revenda?.id, distribuidorRevendaUsuario, distribuidorsState?.data, revendasState, changeValue]);

  return (
      <>
      <Paper elevation={0}>
        <FormDados
          onSaveAndClose={data => onSave(data, afterSave)}
          projetoState={projetoState}
          onChangeValue={(newState: any) => changeValue({ ...newState })}
          errorState={errorState}
          onChangeError={(newErrorState: any) => setErrorState(newErrorState)}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onClickNext={async () => {
            const result = await captureData(projetoState);
            if (!result) return;

            const values: Partial<Projeto> = {
              codigo_venda: result.codigo_venda,
              recebe_servico: mostrarOpcaoServico,
              latitude: projetoState.latitude,
              longitude: projetoState.longitude,
            };

            if (result.estado?.id) {
              const currentRegioes = regioes.data.filter((regiao: any) => {
                const estadosList = regiao.estados || [];
                const estados = estadosList.map((item: any) => item.estado_id);

                return estados.includes(result.estado.id);
              });

              values.regioes = currentRegioes;
            }

            const nextState = {
              ...result,
              ...values,
            };

            changeValue(values);
            onClickNext(nextState);
          }}
        />

      {showMap && (
          <Box px={2}>
            <Map location={{ latitude: Number(projetoState?.latitude), longitude: Number(projetoState?.longitude) }}  />
          </Box>
        )}
      </Paper>
      <Prompt when={!!projetoState?.codigo_venda} message={(location) => {
        if (canNavigate(location)) return true;
        return `Deseja cancelar a ${projetoState?.isEdit ? 'edição' : 'criação'} do projeto?`
      }}/>
    </>
  )    
}

export { ProjetosFormInicialPersonalizadoHibrido }
